"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pulseOkButton = pulseOkButton;
const taskStore_1 = require("../../../taskStore");
function pulseOkButton(waitTime, trialNumber) {
    const okButton = document.querySelector('.primary');
    // make sure we aren't carrying over to the next trial
    if (okButton && (0, taskStore_1.taskStore)().totalTrialCount === trialNumber && !(0, taskStore_1.taskStore)().isPaused) {
        setTimeout(() => {
            if (!okButton.disabled) {
                okButton.style.animation = 'pulse 2s infinite';
            }
        }, waitTime);
    }
}
